import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function AdminLogin() {
  const { user, loading } = useAuth();

  if (loading) return <div className="p-16 text-white/40">Loading…</div>;
  if (user?.is_admin) return <Navigate to="/admin" replace />;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-6 py-32">
      <div className="overline mb-3">Restricted</div>
      <h1 className="font-serif italic text-5xl">Admin sign in.</h1>
      <p className="mt-4 text-white/50">
        Only authorized accounts may manage the catalog.
      </p>
      <button
        type="button"
        onClick={handleLogin}
        data-testid="google-login-button"
        className="mt-10 w-full py-4 bg-white text-black uppercase tracking-[0.22em] text-xs font-semibold hover:bg-white/90"
      >
        Continue with Google
      </button>
      {user && !user.is_admin && (
        <p className="mt-6 text-sm text-red-400" data-testid="not-admin-msg">
          Signed in as {user.email}, but you don&apos;t have admin access.
        </p>
      )}
    </div>
  );
}
